import { eventSummary as mockData } from './mock/oe-event-summary.mock'

// TODO - is this function used?
function isEventSelected(res, id) {
  const e = res.eventTypes.filter(event => {
    return event.id === id && event.selected
  })

  return e.length > 0
}

export function openEnrollmentEventSummaryFactory(response) {
  if (process.env.VUE_APP_OE_MOCK_DATA === 'true') {
    return mockData
  } else {
    const details = []
    response.eventDetails.forEach((event) => {
      if (event.value !== undefined || event.value !== '' || event.value !== null) {
        details.push({
          label: event.label,
          content: event.value,
          showOnSummary: event.showOnSummary
        })
      }
    })
    return details
  }
}
